import { useIntl } from 'react-intl';
import { Schedule } from '@/features/accounts/types';
import { type ScheduleControls } from '@/features/accounts/schedule/hooks/useScheduleControls';
import ClockIcon from '@/shared/components/ClockIcon';
import CogIcon from '@/shared/components/CogIcon';
import PauseIcon from '@/shared/components/PauseIcon';

interface Props {
  schedule: Schedule;
  actions: ScheduleControls;
}

const iconButtonClass = 'rounded p-1 text-slate-400 transition hover:bg-slate-100 hover:text-slate-600';

export default function ScheduleActions({ schedule, actions }: Props) {
  const intl = useIntl();

  return (
    <div className="flex shrink-0 items-center gap-1">
      <button
        type="button"
        onClick={() => actions.viewActivities(schedule)}
        className={iconButtonClass}
        aria-label={intl.formatMessage({ id: 'schedule.activities.title' })}
      >
        <ClockIcon />
      </button>
      {schedule.status === 'active' && (
        <>
          <button
            type="button"
            onClick={() => actions.configure(schedule)}
            className={iconButtonClass}
            aria-label={intl.formatMessage({ id: 'schedule.list.configure' })}
          >
            <CogIcon />
          </button>
          <button
            type="button"
            onClick={() => actions.pause(schedule.id)}
            className={iconButtonClass}
            aria-label={intl.formatMessage({ id: 'schedule.list.pause' })}
          >
            <PauseIcon />
          </button>
        </>
      )}
    </div>
  );
}
